// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2960dbee","453":"a2544771","732":"8c60bdc5","977":"32f388ee"}[chunkId] + ".chunk.js";
};